import * as React from "react";
import { Tree as MantineTree, useTree } from "@mantine/core";
const Tree = ({ ...props }) => /* @__PURE__ */ React.createElement(MantineTree, { ...props });
export { useTree };
export default Tree;
